// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19te6","colBig":"styles_colBig__3l345","colSmall":"styles_colSmall__2WsK7"};